import React, { useState, useEffect } from "react";
import { Form } from "react-formio";
import { useParams, Link } from "react-router-dom";
import { getParticipantSurveyResponse } from "../../Utils/adminFunctions";
import { ToastContainer, toast } from "react-toastify";

let UserParticipantSurveyResponse = () => {
  const { surveyID } = useParams();
  const { participantID } = useParams();
  const [surveyName, setSurveyName] = useState("");
  const [formJson, setFormJson] = useState([]);
  const [dataJson, setDataJson] = useState([]);
  const [companyLogo, setCompanyLogo] = useState("");
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getParticipantSurveyResponse(
        surveyID,
        participantID
      );
      if (response.status == "success") {
        setSurveyName(response.getSurveyName);
        setCompanyLogo(response.getCompanyLogo);
        setFormJson(JSON.parse(response.getFormJson));
        setDataJson(JSON.parse(response.getDataJson));
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  return (
    <>
      <ToastContainer></ToastContainer>
      <section className="query-form-section">
        <div className="container pt-2">
          <div className="create-question-header">
            <div className="row">
              <div className="col-md-12 text-center">
                <img
                  src={companyLogo}
                  alt="image not available"
                  style={{ maxHeight: "40px", minHeight: "40px" }}
                ></img>
              </div>
            </div>
            <div className="row align-items-center mt-4">
              <div
                className="col-md-12 text-center"
                style={{ fontSize: "18px" }}
              >
                <strong>{surveyName}</strong>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-2">
              <Link
                to={"/survey-individual-responses/" + surveyID}
                className="btn btn-sm custom-btn-primary pull-right"
              >
                <i className="fa fa-arrow-left"></i> Back
              </Link>
            </div>
          </div>
          <div className="query-form-info">
            <div className="row form-box-top-margin">
              <div className="col-md-12">
                <div className="form-box_preview">
                  <Form
                    src={{
                      display: "form",
                      components: formJson,
                    }}
                    submission={{
                      data: dataJson,
                    }}
                    options={{ readOnly: true }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserParticipantSurveyResponse;
